import React from "react";

function TermsGreek() {
  return (
    <>
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="Generator" content="Microsoft Word 15 (filtered)" />
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n<!--\n /* Font Definitions */\n @font-face\n\t{font-family:"Cambria Math";\n\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n@font-face\n\t{font-family:"Noto Sans Symbols";\n\tpanose-1:2 11 6 4 2 2 2 2 2 4;}\n /* Style Definitions */\n p.MsoNormal, li.MsoNormal, div.MsoNormal\n\t{margin:0cm;\n\tline-height:115%;\n\tfont-size:11.0pt;\n\tfont-family:"Arial",sans-serif;}\n.MsoChpDefault\n\t{font-size:11.0pt;\n\tfont-family:"Arial",sans-serif;}\n.MsoPapDefault\n\t{line-height:115%;}\n@page WordSection1\n\t{size:595.45pt 841.7pt;\n\tmargin:72.0pt 72.0pt 72.0pt 72.0pt;}\ndiv.WordSection1\n\t{page:WordSection1;}\n /* List Definitions */\n ol\n\t{margin-bottom:0cm;}\nul\n\t{margin-bottom:0cm;}\n-->\n',
        }}
      />
      <div className="WordSection1">
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "24.0pt", lineHeight: "130%" }}>
              ΟΡΟΙ ΧΡΗΣΗΣ
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "24.0pt", lineHeight: "130%" }}>
              &nbsp;
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Τελευταία μετατροπή στις{" "}
            </span>
          </b>
          <b>
            <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              22
            </span>
          </b>
          <b>
            <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              {" "}
            </span>
          </b>
          <b>
            <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Μαρτίου
            </span>
          </b>
          <b>
            <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              {" "}
              202
            </span>
          </b>
          <b>
            <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              5
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Διαβάζετε την πιο πρόσφατη έκδοση των Όρων Χρήσης του Join
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Βασική αλλαγή σε αυτήν την έκδοση: Διαβάζετε την πρώτη έκδοση.{" "}
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Καλώς ήρθατε στο Join. Οι παρακάτω Όροι Χρήσης είναι μεταξύ εσάς και
            του Join<span style={{ background: "yellow" }}> </span>
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Ο όρος «μέλος»{" "}
            </span>
          </b>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            ισχύει για όλα τα άτομα που περιλαμβάνονται στην κοινότητα στο Join,
            που σημαίνει: Όλα τα ενεργά προφίλ/χρήστες της πλατφόρμας
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            .
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Ο όρος "μη μέλος"
            </span>
          </b>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            ισχύει για άτομα που δεν είναι χρήστες του Join με τα οποία μπορεί
            να αλληλεπιδράσει ένας χρήστης του Join στην πραγματική ζωή, σε
            περιβάλλον ή περιστάσεις που οργανώθηκαν και δημοσιεύτηκαν στην
            πλατφόρμα.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Ο όρος «εσείς»
            </span>
          </b>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            σημαίνει το φυσικό πρόσωπο που έχει πρόσβαση στην Υπηρεσία ή την
            εταιρεία ή άλλη νομική οντότητα για λογαριασμό της οποίας το εν λόγω
            άτομο έχει πρόσβαση ή χρησιμοποιεί την Υπηρεσία, ανάλογα με την
            περίπτωση.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Ο όρος «Υπηρεσία»
            </span>
          </b>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            αναφέρεται στην Εφαρμογή
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
              Ο όρος "Εφαρμογή"
            </span>
          </b>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            σημαίνει το πρόγραμμα λογισμικού που κατεβάζετε σε οποιαδήποτε
            ηλεκτρονική συσκευή με το όνομα Join.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              1α. Αποδοχή Όρων Χρήσης.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              &nbsp;
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Δημιουργώντας έναν λογαριασμό στο Join, συμφωνείτε με (i) τους{" "}
          </span>
          <span lang="el">
            <a href="https://join-socialapp.com/gr/terms">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                Όρους Χρήσης
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            , (ii) την{" "}
          </span>
          <span lang="el">
            <a href="http://join-socialapp.com/gr/privacy_policy">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                Πολιτική Απορρήτου
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            και (iii) την{" "}
          </span>
          <span lang="el">
            <a href="https://join-socialapp.com/gr/cookie_policy">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                Πολιτική μας για τα Cookies
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            . Εάν δεν αποδέχεστε και συμφωνείτε να δεσμεύεστε από όλους τους
            όρους της παρούσας Συμφωνίας, μην χρησιμοποιήσετε την Υπηρεσία.
            Σημειώστε ότι παρόλο που αυτή η συμφωνία έχει συνταχθεί βάσει της
            νομοθεσίας της Ελλάδας, πρέπει να την τηρείτε ανεξάρτητα από την
            τοποθεσία σας.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              1β. Αλλαγές στους Όρους Χρήσης.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Κατά καιρούς, μπορεί να σας ζητήσουμε να ελέγξετε αυτό το
            Συμφωνητικό. Αυτό συμβαίνει επειδή ενδέχεται να κάνουμε αλλαγές στην
            Υπηρεσία και στο Συμφωνητικό προκειμένου να βελτιώσουμε την εμπειρία
            του χρήστη ή/και να υιοθετήσουμε αλλαγές που αντικατοπτρίζουν τις
            απαιτήσεις του νόμου. Η πιο πρόσφατη έκδοση είναι η έκδοση που
            ισχύει. Ως εγγεγραμμένος χρήστης, μπορείτε πάντα να το βρείτε{" "}
            <b>στην ενότητα “Νομικά” εντός των Ρυθμίσεων της Εφαρμογής</b>. Σε
            περίπτωση που αποφασίσουμε να ενημερώσουμε αυτήν την έκδοση του
            Συμφωνητικού, με αλλαγές που συνεπάγονται ουσιαστικές αλλαγές στα
            δικαιώματα και τις υποχρεώσεις σας, θα σας ειδοποιήσουμε εγκαίρως
            μέσω email ή με ειδοποίηση, ώστε να μπορείτε να ελέγξετε τις
            αλλαγές, εκτός εάν η ισχύουσα νομοθεσία μας εμποδίζει από το να το
            πράξουμε. Η συνέχιση της χρήσης του Join μετά την έναρξη ισχύος των
            αλλαγών σας καθιστά αυτόματα σύμφωνο με το αναθεωρημένο Συμφωνητικό.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              2. Προϋποθέσεις Συμμετοχής.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              &nbsp;
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Η δημιουργία λογαριασμού ή η πρόσβαση ή η χρήση της Υπηρεσίας είναι
            μη εξουσιοδοτημένη, εκτός εάν ισχύουν όλα τα ακόλουθα:
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            είστε τουλάχιστον 18 ετών
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Θα τηρείτε την παρούσα Συμφωνία και κάθε ισχύοντα τοπικό, εθνικό ή
            διεθνή νόμο, δίκαιο και κανονισμούς.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Δεν σας απαγορεύεται να λαμβάνετε τις υπηρεσίες του Join σύμφωνα με
            την ισχύουσα νομοθεσία
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Δικαιούστε να συνάψετε μια δεσμευτική σύμβαση με το Join
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Η χρήση της Υπηρεσίας δεν απαγορεύεται για εσάς σύμφωνα με τους
            νόμους της Ελλάδας ή οποιαδήποτε άλλη σχετική δικαιοδοσία
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Δεν είστε πρόσωπο που έχει καταδικαστεί για ποινικό αδίκημα ή
            κακούργημα ή έγκλημα παρόμοιας σοβαρότητας, σεξουαλικό έγκλημα ή
            οποιοδήποτε άλλο είδος εγκλήματος βίας
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Δεν έχουμε απενεργοποιήσει ποτέ στο παρελθόν τον λογαριασμό σας για
            παραβιάσεις των Όρων μας. Διαφορετικά, δεν δικαιούστε να
            δημιουργήσετε νέο λογαριασμό.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              3. Ο λογαριασμός σας.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              &nbsp;
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              3.1 Δημιουργία λογαριασμού.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Η δημιουργία λογαριασμού μπορεί να γίνει με δύο τρόπους:
            Χρησιμοποιώντας το email σας ή τη σύνδεση σε τρίτες πλατφόρμες με
            τον υπάρχοντα λογαριασμό σας. Για παράδειγμα, εάν επιλέξετε να
            χρησιμοποιήσετε{" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            συνδεθείτε μέσω λογαριασμού{" "}
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Google
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            , μας εξουσιοδοτείτε να έχουμε πρόσβαση και να χρησιμοποιούμε
            ορισμένες πληροφορίες λογαριασμού
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Google
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            σας
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            , όπως
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            το{" "}
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            email
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            του λογαριασμού
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            . Ρίξτε μια ματιά στα δεδομένα που ενδέχεται να συλλέξουμε από εσάς
            και πώς μπορούμε να τα χρησιμοποιήσουμε στην ενότητα{" "}
          </span>
          <span lang="el">
            <a href="http://join-socialapp.com/gr/privacy_policy">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                Πολιτική Απορρήτου
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            .
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              3.2 Είστε αποκλειστικά υπεύθυνοι για τα στοιχεία σύνδεσης
              (credentials) του λογαριασμού σας
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              &nbsp;
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join δεν έχει καμία νομική ευθύνη σε περίπτωση που δεν καταφέρετε
            να διατηρήσετε την απόκρυψη των στοιχείων σύνδεσης του λογαριασμού
            σας. Κάθε χρήστης είναι αποκλειστικά υπεύθυνος για όλες τις
            δραστηριότητες που πραγματοποιούνται με τα προσωπικά του στοιχεία
            σύνδεσης .
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              4. Αλλαγές στην Υπηρεσία &amp; Τερματισμός.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              4.1 Αλλαγές στην Υπηρεσία
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Η ομάδα του Join μπορεί να τροποποιήσει εν μέρει, να προσθέσει νεές,
            να καταργήσει εξ ολοκλήρου οποιαδήποτε από τις υπάρχουσες
            λειτουργίες της Εφαρμογής ή με άλλον τρόπο να ενημερώσει το
            λογισμικό που χρησιμοποιείτε ή κατεβάζετε, καθώς προσπαθεί πάντα να
            βελτιώσει τη συνολική εμπειρία χρήστη. Μόνο σε περίπτωση που οι
            ενέργειες που περιγράφονται παραπάνω επηρεάζουν ουσιωδώς τα
            δικαιώματα ή/και τις υποχρεώσεις σας, θα σας ειδοποιήσουμε.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              4.2 Τερματισμός Λογαριασμού
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Έχετε το δικαίωμα να τερματίσετε τον λογαριασμό σας ανά πάσα στιγμή,
            για οποιονδήποτε λόγο:{" "}
            <b>
              Μεταβείτε στην Σελίδα του Προφίλ σας - Ρυθμίσεις - Λογαριασμός -
              Διαγραφή Λογαριασμού και ακολουθήστε τα απλά βήματα
            </b>
            . Το Join μπορεί να αναστείλει ή να τερματίσει τον λογαριασμό σας
            ανά πάσα στιγμή χωρίς προειδοποίηση, εάν πιστεύει ότι έχετε
            παραβιάσει την παρούσα Συμφωνία.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Μετά τον τερματισμό του λογαριασμού σας, η παρούσα Συμφωνία θα
            τερματιστεί, με εξαίρεση τις ακόλουθες διατάξεις, οι οποίες θα
            εξακολουθήσουν να ισχύουν: Ενότητες 4, 5.1, 6.2, 6.3, ενότητες 7-11
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              5. Ασφάλεια/ Οι αλληλεπιδράσεις σας με άλλα μέλη και μη μέλη.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              &nbsp;
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              5.1 Απαλλαγή Ευθύνης
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join δεν ευθύνεται για τη συμπεριφορά οποιουδήποτε χρήστη ή
            μέλους της υπηρεσίας ή τα αποτελέσματα που μπορεί να περιλαμβάνουν
            αλληλεπιδράσεις ενός χρήστη με έναν άλλον χρήστη χρήστη, μέλος ή μη
            μέλος του Join στην πραγματική ζωή. Είστε υπεύθυνοι να είστε
            προσεκτικοί όταν συμφωνείτε να αλληλεπιδράτε με άλλα μέλη της
            υπηρεσίας στο διαδίκτυο, στην εφαρμογή αλλά και με μέλη, καθώς και
            με μη μέλη εκτός της εφαρμογής, αυτοπροσώπως. Ανανωρίζετε,
            κατανοείτε και συμφωνείτε με τα ακόλουθα: Το Join δεν είναι υπεύθυνο
            για τη διενέργεια ποινικού ιστορικού ή οποιουδήποτε άλλου είδους
            ελέγχου ιστορικού προφίλ στα μέλη του. Το Join δεν παρέχει καμία
            εγγύηση ή δεσμεύσεις σχετικά με την καλή συμπεριφορά, την ευγένεια
            και την συμβατότητα των μελών. Το Join δεν λαμβάνει καμία ευθύνη για
            τα προφίλ που μπορεί να σας προτείνει ως συμβατά με την
            προσωπικότητα σας, ως “social match”. Οποιαδήποτε προσωπική
            πληροφορία επιλέξετε να αποκαλύψετε άμεσα ή έμμεσα, όπως,
            ενδεικτικά, την τοποθεσία μιας συνάντησης, τα άτομα με τα οποία θα
            συναντηθείτε, την ώρα κ.λπ. , όταν δημοσιεύετε ή συμμετέχετε (join)
            σε μια Εκδήλωση (Event) ή μία Ομάδα (Group), κοινοποιούνται
            αποκλειστικά με δική σας ευθύνη και συγκατάθεση. Είστε αποκλειστικά
            υπεύθυνοι για τις διαδικτυακές και εκτός διαδικτύου αλληλεπιδράσεις
            σας με άλλα μέλη και μη μέλη της πλατφόρμας.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              5.2 Απαγορευμένοι τρόποι χρήσης
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Συμφωνείτε ότι δεν θα χρησιμοποιήσετε την εφαρμογή ως μέσο
            επικοινωνίας για να οργανώσετε ή να εμπλακείτε με άλλο τρόπο σε
            οποιουδήποτε είδους παράνομες ενέργειες και ότι δεν θα κοινοποιήσετε
            καμία από τις οικονομικές σας πληροφορίες: για παράδειγμα, στοιχεία
            της πιστωτικής/χρεωστικής κάρτας ή του τραπεζικού λογαριασμού σας, ή
            να στείλετε χρήματα σε άλλα μέλη. Δεν επιτρέπεται να χρησιμοποιείτε
            τις υπηρεσίες του Join σε ενέργειες που παραβιάζουν τα δικαιώματα
            κάποιου άλλου, συμπεριλαμβανομένης της παραβίασης των δικαιωμάτων
            πνευματικής ιδιοκτησίας του.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              5.3 Κανόνες και Οδηγίες Κοινότητας
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Κατανοείτε και συμφωνείτε ότι δεν θα κάνετε τίποτα από τα ακόλουθα:
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να χρησιμοποιήστε το Join για οποιονδήποτε σκοπό που είναι
            παράνομος, επιβλαβής, ακατάλληλος ή αλλιώς απαγορευμένος από την
            παρούσα Συμφωνία συμφέρον
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να πλαστογραφήσετε ή να παρέχετε αναληθείς πληροφορίες για εσάς στον
            λογαριασμό σας
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να ανεβάστε περιεχόμενο που προστατεύεται από πνευματικά δικαιώματα
            χωρίς την άδεια του κατόχου
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να δημιουργήστε και διατηρήσετε περισσότερους από έναν λογαριασμούς
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να ανταλλάξτε ή να χρησιμοποιήστε λογαριασμούς άλλων μελών
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να δημιουργήστε έναν νέο λογαριασμό εάν το Join έχει τερματίσει τον
            αρχικό σας λογαριασμό
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να κακοποιήσετε ή να παρενοχλήσετε άμεσα άλλα μέλη, ή να προβείτε σε
            βοήθεια ή προτροπή άλλων μελών να εμπλακούν σε οποιαδήποτε
            στοχευμένη κακοποίηση ή παρενόχληση εναντίον οποιουδήποτε άλλου
            μέλους.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να παρακολουθήσετε, να απειλήσετε, να εκφοβίσετε, να επιτεθείτε
            λεκτικά ή σωματικά ή να δυσφημήσετε οποιοδήποτε μέλος και μη μέλος
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να δημιουργήστε και να δημοσιεύστε ψεύτικες Ομάδες (Groups) ή
            ψεύτικες Εκδηλώσεις (Events)
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να μοιραστείτε και να προωθήστε ψεύτικα προφίλ, Ομάδες (Groups) και
            Εκδηλώσεις (Events), για των οποίων δολερότητα είστε ενήμεροι
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να δημοσιεύσετε πορνογραφικό περιεχόμενο, γυμνό περιεχόμενο ή
            σεξουαλικά απόρρητο περιεχόμενο
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να μοιραστείτε περιεχόμενο που προωθεί τον ρατσισμό ή τη βία προς
            μια κοινωνική ομάδα ή ένα συγκεκριμένο μέλος ή μη μέλος
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να προβάλετε δημόσια ή να μεταβιβάσετε με άλλον τρόπο οποιαδήποτε
            οικονομική πληροφορία, όπως τα στοιχεία της κάρτας, τα στοιχεία
            εισόδου του λογαριασμού σας ή άλλες οικονομικές πληροφορίες δικές
            σας ή άλλων
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Να δημοσιεύσετε ιδιωτικές πληροφορίες άλλων μελών ή ατόμων χωρίς τη
            συγκατάθεσή τους
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              6. Τα δικαιώματά σας ως χρήστης του Join.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              6.1 Η άδειά σας και οι ισχύοντες κανόνες
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Ως χρήστης του Join, δικαιούστε μια μη υποαδειοδοτούμενη, προσωπική,
            μη αποκλειστική, παγκόσμια, χωρίς δικαιώματα εκμετάλλευσης, μη
            μεταβιβάσιμη και αμετάκλητη άδεια που σας παρέχει πρόσβαση και άδεια
            χρήσης της υπηρεσίας. Η εξουσιοδότησή σας για χρήση της υπηρεσίας
            του Join όπως προορίζεται και σχεδιάστηκε από το Join είναι ο μόνος
            σκοπός της προαναφερθείσας άδειας χρήσης και αυτή η άδεια παύει
            αυτόματα να ισχύει εάν ισχύει ή ίσχυσε κάποιο από τα ακόλουθα:
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Ενθαρρύνετε ή προωθείτε οποιεσδήποτε ενέργειες που παραβιάζουν την
            παρούσα Συμφωνία.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Εκμεταλλεύεστε την Εφαρμογή ή στοιχεία που περιέχονται στην Εφαρμογή
            για εμπορικούς σκοπούς χωρίς τη γραπτή μας συγκατάθεση.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Διαδίδετε, αντιγράφετε ως έχουν, τροποποιείτε εξ ολοκλήρου ή
            δημιουργείτε/αναπαράγετε παράγωγα στοιχεία ή κάνετε χρήση
            οποιουδήποτε υλικού ή πνευματικής ιδιοκτησίας που προστατεύεται από
            πνευματικά δικαιώματα, όπως εικόνες, εμπορικά σήματα και εμπορικές
            ονομασίες ή οποιοδήποτε άλλο μη γενικό περιεχόμενο που λαμβάνετε
            μέσω της Υπηρεσίας, αντιγράψετε ή εκχωρήσετε περαιτέρω άδεια για την
            χρήση τμήματος της υπηρεσίας του Join χωρίς τη γραπτή μας
            εξουσιοδότηση.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Δηλώνετε ή υπονοείτε ότι τυχόν δηλώσεις που μπορεί να κάνετε είναι
            διαπιστευμένες ή εγκεκριμένες από την Join, εκτός εάν έχετε τη
            γραπτή συγκατάθεσή μας.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Ανεβάζετε ιούς, άλλους τύπους κακόβουλου κώδικα,&nbsp;
            χρησιμοποιείτε τις υπηρεσίες για την αποστολή ανεπιθύμητων μηνυμάτων
            ή κάνετε οτιδήποτε άλλο θα μπορούσε να θέσει σε κίνδυνο, να
            απενεργοποιήσει, να επιβαρύνει υπερβολικά, να παρεμποδίσει ή να
            βλάψει τη σωστή λειτουργία, ακεραιότητα, λειτουργία ή εμφάνιση της
            Υπηρεσίας ή των διακομιστών (servers) ή δίκτυα που είναι συνδεδεμένα
            στην Υπηρεσία.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Έχετε πρόσβαση ή συλλέγετε δεδομένα από την Εφαρμογή χρησιμοποιώντας
            αυτοματοποιημένα μέσα, χωρίς τη γραπτή συγκατάθεσή μας ή επιδιώκετε
            την πρόσβαση σε δεδομένα στα οποία δεν επιτρέπεται να έχετε
            πρόσβαση.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Χρησιμοποιείτε διακομιστές μεσολάβησης, συλλέγετε ή αναζητάτε
            ονόματα χρηστών, κωδικούς πρόσβασης ή διακριτικά πρόσβασης (access
            tokens) μέσω από την Υπηρεσία.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Δημιουργείτε ή χρησιμοποιείτε οποιοδήποτε είδος λογισμικού που
            αλληλεπιδρά με το Join ή τις μη γενικές πληροφορίες των χρηστών του
            χωρίς τη γραπτή μας εξουσιοδότηση.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Εξετάζετε ή δοκιμάζετε την ακεραιότητα και την αδιαπερατότητα της
            Εφαρμογής ή οποιουδήποτε συστήματος ή δικτύου της Υπηρεσίας.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              6.2 Ενέργειες κατά της κακής χρήσης των υπηρεσιών Εφαρμογών
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Είναι αποκλειστική ευθύνη του χρήστη να συμμορφώνεται με τα
            δικαιώματα της κοινότητας και να σέβεται αυτή τη συμφωνία. Παρόλο
            που το Join δεν εγγυάται ότι όλο το περιεχόμενο θα συμμορφώνεται με
            αυτήν τη συμφωνία, το Join διατηρεί το δικαίωμα να λάβει οποιοδήποτε
            από τα ακόλουθα βήματα εάν, κατά την κρίση μας, διαπιστώσουμε
            παράνομη ή μη εξουσιοδοτημένη χρήση των υπηρεσιών της Εφαρμογής ή
            ασέβεια προς άλλα μέλη και μη μέλη ή εξυπηρέτηση πελατών Join:
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Αναστολή, προσωρινή απενεργοποίηση ή τερματισμός του λογαριασμού σας
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Απόσυρση κοινόχρηστου/ανεβασμένου περιεχομένου
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Δικαστική διαδικασία
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Κατάργηση ή περιορισμός της πρόσβασής σας σε περιεχόμενο, δεδομένα,
            λειτουργίες ή/και υπηρεσίες
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Με στόχο την προστασία και την υποστήριξη της κοινότητάς μας, σας
            ενθαρρύνουμε να υποβάλετε αναφορά των συμπεριφορών ή περιεχομένου
            που μπορεί να έχουν δημιουργήσει υποψίες ή προφανώς παραβιάζουν τα
            δικαιώματά σας ή την παρούσα συμφωνία. Παρακαλούμε{" "}
            <b>
              πηγαίνετε στην Σελίδα Προφίλ σας - Ρυθμίσεις - Αναφορά Προβλήματος
            </b>{" "}
            και αναφέρετε το ως παραβίαση των Κανόνων της Κοινότητας του Join.
            Σας προτρέπουμε να χρησιμοποιήσετε την ίδια φόρμα για να
            επικοινωνήσετε μαζί μας εάν πιστεύετε ότι απενεργοποιήσαμε
            αδικαιολόγητα τον λογαριασμό σας.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              6.3 Διατήρηση ιδιοκτησίας
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Διατηρείτε πάντα την κυριότητα των δικαιωμάτων πνευματικής
            ιδιοκτησίας: πνευματικών δικαιωμάτων ή εμπορικών σημάτων σε
            οποιοδήποτε αντίστοιχο περιεχόμενο που δημιουργείτε ή κοινοποιείτε
            στο Join. Αυτή η συμφωνία δηλώνει ότι παραμένετε εντελώς ελεύθεροι
            να χρησιμοποιείτε το περιεχόμενό σας όποτε και όπου θέλετε.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Εάν διαπιστώσετε ότι το περιεχόμενο, στο οποίο κατέχετε ιδιοκτησία ή
            περιεχόμενο που προστατεύεται από πνευματικά δικαιώματα, έχει
            αντιγραφεί ή έχει χρησιμοποιηθεί με τρόπο που συνιστά παραβίαση
            πνευματικών δικαιωμάτων, μπορείτε να μεταβείτε
            <b> στην Σελίδα Προφίλ σας - Ρυθμίσεις - Αναφορά Προβλήματος</b> και
            αναφέρετε το πρόβλημα. Πρέπει να συμπεριλαμβάνονται τα ακόλουθα στο
            κείμενό σας για να υποστηρίξετε τη δήλωσή σας:
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            1)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Η διεύθυνση email σας, ο αριθμός τηλεφώνου και το πλήρες όνομα του
            κατόχου των πνευματικών δικαιωμάτων. Ενδέχεται να σας ζητήσουμε να
            αποκαλύψετε περισσότερες πληροφορίες σχετικά με τα προαναφερθέντα.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            2)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Περιγραφή τοποθεσίας της παράβασης, πώς και πού εντοπίζεται η
            παράβαση στην Υπηρεσία
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            3)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Περιγραφή του περιεχομένου που παραβιάζεται
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Πρέπει επίσης να στείλετε στο{" "}
          </span>
          <span lang="el">
            <a href="mailto:info@join-socialapp.com">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                info@join-socialapp.com
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            ένα αντίτυπο ενός εγγράφου που:
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Χορηγεί γραπτή άδεια στο πρόσωπο που είναι εξουσιοδοτημένο να
            ενεργεί για λογαριασμό του κατόχου των πνευματικών δικαιωμάτων
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Περιλαμβάνει γραπτή δήλωση του κατόχου των πνευματικών δικαιωμάτων
            ότι η αμφισβητούμενη χρήση του υπό εξέταση περιεχομένου δεν έχει
            εξουσιοδοτηθεί από αυτόν, έναν αντιπρόσωπο ή από το νόμο.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Περιλαμβάνει μια ένορκη δήλωση, που γίνεται με την ποινή της
            ψευδορκίας είτε από εσάς είτε από τον κάτοχο των πνευματικών
            δικαιωμάτων, ότι όλες οι πληροφορίες που παρέχετε είναι αληθείς και
            ακριβείς
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Υπογράφεται ηλεκτρονικά ή φυσικά από εσάς (που είστε το
            εξουσιοδοτημένο πρόσωπο) και τον κάτοχο των πνευματικών δικαιωμάτων,
            εκτός εάν ο κάτοχος των πνευματικών δικαιωμάτων είστε εσείς. Σε αυτή
            την περίπτωση αρκεί μια υπογραφή.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Απαιτούνται όλα τα προαναφερθέντα στοιχεία. Αναφορές για παραβίαση
            πνευματικών δικαιωμάτων που δεν πληρούν τη συμπερίληψη όλων των
            απαιτούμενων στοιχείων θα θεωρούνται ανεπαρκείς και το Join μπορεί
            να τις παραλείψει εντελώς.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              7. Τα δικαιώματα του Join
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              7.1 Η άδεια που παραχωρείτε στο Join
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Με αυτήν τη συμφωνία, παραχωρείτε στο Join άδεια και δικαίωμα
            χρήσης, αποθήκευσης, τροποποίησης, εμφάνισης, προσαρμογής,
            αναπαραγωγής, δημοσίευσης και διανομής δεδομένων, πληροφοριών,
            σχολίων και περιεχομένου που παρέχετε στο Join απευθείας,
            μεταφορτώνοντας ή δημοσιεύοντας ή εμμέσως παρέχοντας μέσω τρίτων
            υπηρεσιών όπως της
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            ταυτοποίησης μέσω{" "}
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Google
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            ή καθιστώντας με άλλο τρόπο διαθέσιμο και εμφανιζόμενο στην Εφαρμογή
            χωρίς να δικαιούστε αποζημίωση. Τα παραπάνω περιλαμβάνουν αλλά δεν
            περιορίζονται σε προσωπικές πληροφορίες όπως το Όνομα, την ηλικία,
            το{" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Εκπαιδευτικό Ίδρυμα
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            , τη σεξουαλικότητα, τα αγαπημένα χόμπι και τα ενδιαφέροντά σας, τις
            φωτογραφίες, τις αλληλεπιδράσεις σας με άλλους χρήστες και άλλα.
            Όποτε χρειαζόμαστε μια νέα εξουσιοδότηση από εσάς, προκειμένου να
            αποκτήσουμε πρόσβαση σε συγκεκριμένες λειτουργίες, θα σας ζητήσουμε
            συγκεκριμένα να μας την παραχωρήσετε. Κατανοείτε και συμφωνείτε ότι
            οποιοδήποτε περιεχόμενο που διαθέτετε στην Υπηρεσία ή μας
            εξουσιοδοτείτε να διαθέτουμε στην Υπηρεσία μπορεί να προβληθεί από
            άλλους χρήστες/μέλη ή μη μέλη, που ενδέχεται να λαμβάνουν αυτό το
            περιεχόμενο από άλλους χρήστες του Join.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Αυτή η άδεια είναι παγκόσμια, υποαδειοδοτήσιμη, μεταβιβάσιμη, μη
            αποκλειστική, παγκόσμια και χωρίς δικαιώματα εκμετάλλευσης.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              7.2 Αποκάλυψη περιεχομένου
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Κατανοείτε ότι το Join έχει το δικαίωμα, εξασκώντας αυτήν τη
            συμφωνία μαζί σας, να αποθηκεύει, να έχει πρόσβαση και να
            αποκαλύπτει οποιαδήποτε δεδομένα, πληροφορίες, σχόλια και
            περιεχόμενο που παρέχετε άμεσα ή έμμεσα στο Join, εάν αυτό
            απαιτείται ή συμβουλεύεται να το πράξουμε από το νόμο ή εμείς
            κρίνουμε ότι υπάρχουν βάσιμοι λόγοι για να αποφασίσουμε ότι τέτοιες
            ενέργειες θα ικανοποιούσαν ένα έννομο συμφέρον, συμπεριλαμβανομένων
            των εξής:
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Έλεγχος αναφορών ότι έχετε παραβιάσει την παρούσα Συμφωνία
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Εξυπηρέτηση πελατών ως απάντηση στα αιτήματά σας
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Προστασία της ασφάλειας και της ακεραιότητας της εφαρμογής, των
            συστημάτων και των υπηρεσιών ή της ασφάλειας οποιουδήποτε άλλου
            ατόμου, χρήστη/μέλους ή πρώην χρήστη/μέλους
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Για να υπερασπιστούμε και να προστατεύσουμε τους χρήστες, τους
            συνεργάτες μας και τους εαυτούς μας
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              7.3 Ενεργοποίηση ιδιωτικού λογαριασμού
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              &nbsp;
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Μπορείτε να περιορίσετε την έκθεση του προφίλ σας ενεργοποιώντας την
            Ιδιωτική λειτουργία στις σχετικές ρυθμίσεις:{" "}
            <b>
              Πηγαίνετε στην Σελίδα Προφίλ σας - Ρυθμίσεις - Η ιδιωτικότητα Σου
              και τέλος ενεργοποιήστε την ιδιωτική λειτουργία πατώντας τον μοχλό
            </b>
            . Θέλουμε να σας ενημερώσουμε πως ότι η ενεργοποίηση της Ιδιωτικής
            λειτουργίας πιθανώς να περιορίσει την εμπειρία σας στο Join..
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              7.4 Υποχρεωτική ειλικρίνεια του τοποθετημένου περιεχομένου
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              &nbsp;
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Συμφωνείτε ότι οποιαδήποτε δεδομένα καθιστάτε διαθέσιμα στην
            Υπηρεσία ή μας εξουσιοδοτείτε να διαθέσουμε στην Υπηρεσία είναι
            ακριβή και αληθή. Το Join έχει πλήρη εξουσία να ελέγχει, να κρίνει
            και να αποφασίζει τη μερική ή πλήρη διαγραφή περιεχομένου που
            παραβιάζει την παρούσα Συμφωνία ή δεν ευθυγραμμίζεται με ή θα
            μπορούσε να βλάψει τη φήμη της Εφαρμογής.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              7.5 Χρονικό πλαίσιο αποθήκευσης περιεχομένου
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Συμφωνείτε ότι τα προαναφερθέντα δεδομένα, πληροφορίες, σχόλια και
            περιεχόμενο θα αποθηκευτούν και θα είναι προσβάσιμα από το Join στη
            βάση δεδομένων μας για όλη τη διάρκεια του ενεργού λογαριασμού σας
            και σε περίπτωση τερματισμού λογαριασμού, για επιπλέον 90 (ενενήντα)
            ημέρες, από την ημέρα της αίτησης διαγραφής. Όπου η διαγραφή του
            περιεχομένου σας είναι αδύνατη για τεχνικούς λόγους, κατανοείτε και
            συμφωνείτε ότι θα ολοκληρώσουμε τη διαγραφή όταν είναι τεχνικά
            εφικτό. Άλλοι λόγοι που δύναται να αποτρέψουν την άμεση διαγραφή
            μετά την περίοδο των 90 ημερών μετά το αίτημα διαγραφής του
            λογαριασμού σας είναι η προστασία της ακεραιότητας και της ασφάλειας
            της εφαρμογής, των συστημάτων και των υπηρεσιών μας ή/και για την
            προστασία ή υπεράσπιση της κοινότητάς μας: συνεργάτες, χρήστες/μέλη,
            πρώην χρήστες/μέλη, τον εαυτό μας ή οποιοδήποτε άλλο πρόσωπο.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              7.6 Υπηρεσίες τρίτων και Διαφήμιση
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join έχει το δικαίωμα να προβάλει διάφορους τύπους διαφημίσεων
            και προωθητικού υλικού, όπως το να τοποθετεί απευθείας διαφημίσεις,
            χορηγούμενο και εμπορικό περιεχόμενο της επιλογής μας ή έμμεσα
            προσφέροντας την υπηρεσία διαφήμισης μέσω Join σε τρίτους χωρίς να
            σας αποζημιώσει. Οι διαφημίσεις και οι προωθήσεις μπορεί να
            πραγματοποιούνται μέσω συνδέσμων προς άλλους ιστότοπους, πλατφόρμες
            ή άλλα μέσα και το Join δεν αναλαμβάνει ευθύνη ούτε παρέχει
            εγγυήσεις για τη διαθεσιμότητα ή την έλλειψη διαθεσιμότητας τέτοιων
            εξωτερικών μέσων. Το Join δεν ευθύνεται σε καμία περίπτωση για τους
            όρους και τις προϋποθέσεις ή τις ενέργειες τρίτων.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "13.0pt", lineHeight: "130%" }}>
              7.7 Απαραίτητη Επικοινωνία
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Με τη δημιουργία και τη διατήρηση ενός λογαριασμού συμφωνείτε να
            επικοινωνούμε με την καταχωρημένη διεύθυνση ηλεκτρονικού
            ταχυδρομείου σας, όταν αυτό αποτελεί απαραίτητο επακόλουθο της
            δραστηριότητάς σας στην Υπηρεσία.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              8. Αποποίηση Ευθύνης
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join δεν φέρει καμία ευθύνη για λάθη ή παραλείψεις στο
            περιεχόμενο της Υπηρεσίας. Η υπηρεσία παρέχεται «ως έχει» και «ως
            διατίθεται». Σε καμία περίπτωση το Join δεν φέρει ευθύνη για
            οποιαδήποτε από, αλλά χωρίς περιορισμό στα ακόλουθα: ειδικές,
            άμεσες, έμμεσες, παρεπόμενες ή συμπτωματικές ζημίες ή οποιαδήποτε
            επιπλοκή, είτε σε ενέργεια σύμβασης, αμέλεια ή άλλη αδικοπραξία, που
            προκύπτουν από ή σε συνδέεται με τη χρήση της Υπηρεσίας ή το
            περιεχόμενο της Υπηρεσίας και δεν παρέχει εγγυήσεις ικανοποιητικής
            ποιότητας, εμπορευσιμότητας, καταλληλό
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            τ
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            ητας για συγκεκριμένο σκοπό ή μη παραβίασης. Το Join διατηρεί το
            δικαίωμα να κάνει προσθήκες, διαγραφές ή τροποποιήσεις στα
            περιεχόμενα της Υπηρεσίας ανά πάσα στιγμή χωρίς προηγούμενη
            ειδοποίηση, εκτός εάν αυτές οι αλλαγές επηρεάζουν ουσιαστικά τα
            δικαιώματα ή/και τις υποχρεώσεις σας. Σε τέτοιες περιπτώσεις θα
            παρέχουμε ειδοποίηση. Το Join δεν παρέχει καμία εγγύηση ότι η
            υπηρεσία θα είναι αδιάλειπτη, ασφαλής και απαλλαγμένη από ιούς ή
            άλλα επιβλαβή στοιχεία ή ότι θα παρέχεται χωρίς σφάλματα.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Οι πληροφορίες σχετικά με την Υπηρεσία παρέχονται με την κατανόηση
            σας ότι το Join δεν ασχολείται με την παροχή νομικών, λογιστικών,
            φορολογικών ή άλλων επαγγελματικών συμβουλών και υπηρεσιών. Ως εκ
            τούτου, δεν θα πρέπει να χρησιμοποιείται ως υποκατάστατο για
            διαβούλευση με επαγγελματίες λογιστικούς, φορολογικούς, νομικούς ή
            άλλους αρμόδιους συμβούλους.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Σε καμία περίπτωση το Join δεν φέρει ευθύνη για τυχόν ειδικές,
            τυχαίες, έμμεσες ή επακόλουθες ζημίες ή προβλήματα&nbsp; που
            προκύπτουν από ή σε σχέση με την πρόσβασή σας ή τη χρήση ή την
            αδυναμία πρόσβασης ή χρήσης της Υπηρεσίας.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join δεν φέρει καμία ευθύνη και δεν παρέχει καμία εγγύηση σχετικά
            με οποιοδήποτε περιεχόμενο που εσείς ή οποιοσδήποτε άλλος χρήστης ή
            μέλος ή τρίτο μέρος κοινοποιεί, ανεβάζει, δημοσιεύει, στέλνει ή
            λαμβάνει στην Εφαρμογή. Οποιοδήποτε υλικό ληφθεί ή αποκτάται με
            άλλον τρόπο μέσω της Υπηρεσίας γίνεται με δική σας αποκλειστική
            ευχέρεια και ευθύνη.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join δεν φέρει καμία ευθύνη και δεν παρέχει καμία εγγύηση σχετικά
            με οποιαδήποτε συμπεριφορά ή τυχόν γεγονότα που μπορεί να βιώσετε
            εσείς ή οποιοσδήποτε άλλος χρήστης, μέλος και μη μέλος της Υπηρεσίας
            στην πραγματική ζωή σε ένα περιβάλλον που κοινοποιήθηκε,
            δημοσιεύτηκε ή δημιουργήθηκε στο Join και δεν παρέχει καμία εγγύηση
            ότι οι{" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            τα «Μαγαζία» τα «Μεγάλα{" "}
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Events
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            », τα «
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Events
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Χρηστών» η οποιοδήποτε άλλο υλικό, μέρη και επιχειρήσεις
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            , που απεικονίζονται στην υπηρεσία, θα ανταπεξέλθουν στις προσδοκίες
            του χρήστη στην πραγματική ζωή. Το Join δεν εγγυάται ότι οι
            πληροφορίες που απεικονίζονται για κάθε{" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Επιχείρηση και Εκδήλωση{" "}
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            που{" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            έχει
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            δημοσιευτεί στο Join από το εξουσιοδοτημένο προσωπικό του είναι
            ακριβείς. Οι φωτογραφίες, οι ώρες λειτουργίας, οι τοποθεσίες και
            όλες οι άλλες πληροφορίες που σχετίζονται με{" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Επιχειρήσεις και Εκδηλώσεις
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            στην εφαρμογή ενδέχεται να είναι ανακριβείς ή μη ενημερωμένες.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{ marginLeft: "36.0pt", lineHeight: "130%" }}
        >
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join δεν αποτελεί πλατφόρμα κρατήσεων και δεν εγγυάται ότι οι
            χρήστες θα έχουν πρόσβαση ή θα βρουν τραπέζι ή θέση σε οποιοδήποτε
            από τα «Μαγαζία», «Μεγάλα{" "}
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Event
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            » ή «
          </span>
          <span lang="EN-US" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Event
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            χρηστών» που εμφανίζονται στην εφαρμογή. Το Join δεν φέρει καμία
            ευθύνη και δεν παρέχει καμία εγγύηση σχετικά με την εμπειρία σας
            στην πραγματική ζωή που σχετίζεται με οποιαδήποτε από τις
            προαναφερθείσες τοποθεσίες. Σε καμία περίπτωση το Join δεν θα
            θεωρηθεί υπεύθυνο για οποιαδήποτε δυσαρέσκεια, ζημίες ή ζητήματα που
            προκύπτουν από την πρόσβαση ή την αλληλεπίδρασή σας με τις εν λόγω
            τοποθεσίες.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join δεν θα είναι υπεύθυνο έναντι Εσάς ή οποιουδήποτε άλλου για
            οποιαδήποτε απόφαση ή ενέργεια που λαμβάνεται βάσει των πληροφοριών
            που δίνονται από την Υπηρεσία ή για τυχόν επακόλουθες, ειδικές ή
            παρόμοιες αποζημιώσεις σε καμία περίπτωση.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: "36.0pt",
            textIndent: "-18.0pt",
            lineHeight: "130%",
          }}
        >
          <span
            lang="el"
            style={{
              fontSize: "12.0pt",
              lineHeight: "130%",
              fontFamily: '"Noto Sans Symbols"',
            }}
          >
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Στο μέγιστο βαθμό που επιτρέπεται από την ισχύουσα νομοθεσία, σε
            καμία περίπτωση το Join δεν θα είναι υπεύθυνο για τυχόν επακόλουθες,
            έμμεσες, τιμωρητικές, ή επικουρικές ζημιές, συμπεριλαμβανομένων αλλά
            όχι αποκλειστικά των ακόλουθων: λεκτική ή σωματική επίθεση, θάνατος,
            απώλεια κερδών, απώλεια καλής θέλησης, απώλεια δεδομένων ή
            οποιαδήποτε άλλα προσωπικά ζητήματα, όπως ψυχολογική βλάβη ή άλλα
            ζητήματα που σχετίζονται με την υγεία, είτε προκύπτουν άμεσα είτε
            έμμεσα, που προκύπτουν από (Ι) την πρόσβασή σας ή τη χρήση της ή
            αδυναμίας χρήσης ή πρόσβασης στην Υπηρεσία (II) την συμπεριφορά
            άλλων χρηστών ή τρίτων στο διαδίκτυο (III) τις αλληλεπιδράσεις σας
            με μέλη και μη μέλη στο Join και στην πραγματική ζωή, (IV) η
            πραγματική εμπειρία σας που σχετίζεται με οποιαδήποτε από τις{" "}
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            τοποθεσίες
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            που εμφανίζονται στην Εφαρμογή και (V) μη εξουσιοδοτημένη πρόσβαση ή
            χρήση ή τροποποίηση του περιεχομένου σας
          </span>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            .
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              9.{" "}
            </span>
          </b>
          <b>
            <span
              lang="EN-US"
              style={{ fontSize: "18.0pt", lineHeight: "130%" }}
            >
              T
            </span>
          </b>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              οποθεσίες
            </span>
          </b>
          <b>
            <span lang="EL" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              {" "}
              – Επιχειρήσεις και Εκ
            </span>
          </b>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              δηλώσεις
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Το Join δεν συνάπτει αμειβόμενες συνεργασίες, συμπράξεις ή συμφωνίες
            με τις επιχειρήσεις ή τις εκδηλώσεις που εμφανίζονται στην εφαρμογή,
            εκτός εάν προβλέπεται ρητά σε ξεχωριστή συμβατική ρύθμιση. Το Join
            δεν χρησιμοποιεί αυτές τις επιχειρήσεις ή εκδηλώσεις με σκοπό τη
            δημιουργία κέρδους ή την εκτροπή εσόδων από αυτές. Αντίθετα, το Join
            παρέχει δωρεάν διαφήμιση για αυτές τις επιχειρήσεις και εκδηλώσεις
            χρησιμοποιώντας δημόσια διαθέσιμες πληροφορίες που προέρχονται από
            τον ιστό, εκτός εάν ορίζεται διαφορετικά σε επίσημη συμφωνία με τα
            αντίστοιχα μέρη.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="EL" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="EL" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              10
            </span>
          </b>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              . Διαφωνίες
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Σε περίπτωση αξίωσης ή διαφοράς που σχετίζεται με την εμπειρία σας
            με την Υπηρεσία, ως χρήστης της Υπηρεσίας, τόσο εσείς όσο και η Join
            συμφωνούμε αμφότεροι πως{" "}
            <span style={{ background: "white" }}>
              θα μπορούμε να προσφύγουμε σε οποιοδήποτε αρμόδιο δικαστήριο{" "}
            </span>
            στην περιφέρεια Αττικής, στην Ελλάδα που έχει δικαιοδοσία επί της
            αξίωσης ή διαφοράς{" "}
            <span style={{ background: "white" }}>
              για την επίλυση των ατομικών αξιώσεων ή διαφορών που έχουν
              ανακύψει μεταξύ μας
            </span>
            . Οι νόμοι της Ελλάδας θα εφαρμόζονται χωρίς να λαμβάνεται υπόψη η
            σύγκρουση νόμων.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              1
            </span>
          </b>
          <b>
            <span lang="EL" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              1.
            </span>
          </b>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              {" "}
              Πώς να επικοινωνήσετε μαζί μας
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με αυτήν την Πολιτική
            Απορρήτου, χρησιμοποιήστε αυτήν τη{" "}
          </span>
          <span lang="el">
            <a href="https://join-socialapp.com/contact">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                φόρμα επικοινωνίας
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            .
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              1
            </span>
          </b>
          <b>
            <span lang="EL" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              2
            </span>
          </b>
          <b>
            <span lang="el" style={{ fontSize: "18.0pt", lineHeight: "130%" }}>
              . Ολόκληρη η Συμφωνία.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            Η παρούσα Συμφωνία, στην οποία περιλαμβάνονται οι{" "}
          </span>
          <span lang="el">
            <a href="https://join-socialapp.com/gr/terms">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                Όροι Χρήσης
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            , η{" "}
          </span>
          <span lang="el">
            <a href="https://join-socialapp.com/gr/privacy_policy">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                Πολιτική Απορρήτου
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            {" "}
            και η{" "}
          </span>
          <span lang="el">
            <a href="https://join-socialapp.com/gr/cookie_policy">
              <span
                style={{
                  fontSize: "12.0pt",
                  lineHeight: "130%",
                  color: "#1155CC",
                }}
              >
                Πολιτική μας για τα cookies
              </span>
            </a>
          </span>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            , αποτελεί την πλήρη και μοναδική έγκυρη συμφωνία μεταξύ εσάς και
            του Join σχετικά με τη χρήση της Εφαρμογής. Αντικαθιστά οποιεσδήποτε
            προηγούμενες συμφωνίες. Σε περίπτωση που οποιοσδήποτε όρος ή διάταξη
            της παρούσας Συμφωνίας είναι ανεφάρμοστος, το μη εκτελεστό τμήμα θα
            θεωρείται ότι έχει τροποποιηθεί στον ελάχιστο απαραίτητο βαθμό για
            να καταστεί εκτελεστό και το υπόλοιπο της παρούσας Συμφωνίας θα
            συνεχίσει να ισχύει και θα ισχύει. Εάν το Join δεν ασκήσει ή δεν
            επιβάλει οποιοδήποτε δικαίωμα ή διάταξη της παρούσας Συμφωνίας, δεν
            θα θεωρείται παραίτηση από{" "}
            <span style={{ background: "white" }}>
              το εν λόγω δικαίωμα ή την εν λόγω διάταξη
            </span>
            . Οποιαδήποτε τροποποίηση ή παραίτηση από αυτούς τους Όρους πρέπει
            να γίνεται γραπτώς και να υπογράφεται από εμάς. Κατανοείτε και
            συμφωνείτε ότι δεν θα μεταβιβάσετε κανένα από τα δικαιώματα ή τις
            υποχρεώσεις σας βάσει των παρόντων Όρων σε κανέναν άλλον χωρίς τη
            συγκατάθεσή μας και ότι ο λογαριασμός σας στο Join δεν
            μεταβιβάζεται, πράγμα που σημαίνει ότι όλα τα δικαιώματά σας στον
            λογαριασμό σας και στο Περιεχόμενό του λήγουν με το θάνατό σας.
            Καμία σχέση συνεργασίας, εταιρική σχέση, κοινοπραξία ή άλλου τύπου
            δεσμευτική ή ειδική σχέση ή απασχόληση δεν δημιουργείται σε διαδοχή
            της παρούσας Συμφωνίας και σε καμία περίπτωση δεν επιτρέπεται να
            προβείτε σε δηλώσεις εκ μέρους του Join ή να δεσμεύσετε το Join με
            οποιοδήποτε μέσο.
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ lineHeight: "130%" }}>
          <span lang="el" style={{ fontSize: "12.0pt", lineHeight: "130%" }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="el">&nbsp;</span>
        </p>
      </div>
    </>
  );
}

export default TermsGreek;
